import { Fade, Paper, Popper } from '@mui/material';
import React from 'react';
import { ITkToolTipProps } from '../../../type/componentsType/TkTooltip';
import './_style.scss';

/**
 * TkToolTipコンポーネントの定義
 * ツールチップコンポーネント
 * 
 * @param {ITkToolTipProps} props - ツールチップのプロパティ
 * @param {boolean} props.open - ツールチップが開いているかどうかを示すフラグ
 * @param {HTMLElement} props.anchorEl - ツールチップのアンカーエレメント
 * @param {string} [props.placement="bottom"] - ツールチップの表示位置
 * @param {ReactNode} props.children - ツールチップの内容
 * @returns {ReactElement} ツールチップコンポーネント
 */
const TkToolTip: React.FC<ITkToolTipProps> = (props) => {
  const { open, anchorEl, placement = "bottom",  ...rest } = props;

  return (
    <Popper
        open={open}
        anchorEl={anchorEl}
        placement={placement}
        transition
        sx={{ zIndex: 999 }}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className='tkToolTip'>
              {rest.children}
            </Paper>
          </Fade>
        )}
      </Popper>
  );
};

export default TkToolTip;
